var DependentsListDataTestIdEnum = /* @__PURE__ */ ((DependentsListDataTestIdEnum2) => {
  DependentsListDataTestIdEnum2["DEPENDENTS_LIST_ADD_DEPENDENT_BUTTON"] = "dependents-list-add-dependent-button";
  DependentsListDataTestIdEnum2["DEPENDENTS_DISCARD_CHANGES_MODAL"] = "dependents-discard-changes-modal";
  DependentsListDataTestIdEnum2["DEPENDENTS_DISCARD_CHANGES_MODAL_TITLE"] = "dependents-discard-changes-modal-title";
  DependentsListDataTestIdEnum2["DEPENDENTS_DISCARD_CHANGES_MODAL_SAVE_BUTTON"] = "dependents-discard-changes-modal-save-button";
  DependentsListDataTestIdEnum2["DEPENDENTS_DISCARD_CHANGES_MODAL_DISCARD_BUTTON"] = "dependents-discard-changes-modal-discard-button";
  return DependentsListDataTestIdEnum2;
})(DependentsListDataTestIdEnum || {});
export {
  DependentsListDataTestIdEnum
};
